import React from "react";
import PropTypes from "prop-types";
import { formatUtcForLocalDisplay } from "utils/date";

const ArrivalPhotoDisplay = ({ arrivalPhoto, arrivalTime }) => {
  if (!arrivalPhoto) {
    return null;
  }

  // Format UTC timestamp for display in local timezone using French locale
  const formatTimestamp = (utcTimestamp) => {
    return formatUtcForLocalDisplay(utcTimestamp);
  };

  return (
    <div className="arrival-photo-display">
      <div className="arrival-photo-display__header">
        <h4 className="arrival-photo-display__title">
          <i className="fas fa-camera" aria-hidden="true"></i>
          Photo d&apos;arrivée chez le client
        </h4>
        {arrivalTime && (
          <div className="arrival-photo-display__timestamp">
            <i className="fas fa-clock" aria-hidden="true"></i>
            Arrivée: {formatTimestamp(arrivalTime)}
          </div>
        )}
      </div>
      <div className="arrival-photo-display__photo-container">
        <img
          src={arrivalPhoto}
          alt="Arrivée chez le client"
          className="arrival-photo-display__photo"
        />
      </div>
    </div>
  );
};

ArrivalPhotoDisplay.propTypes = {
  arrivalPhoto: PropTypes.string,
  arrivalTime: PropTypes.string,
};

export default ArrivalPhotoDisplay;
